import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthService } from '../../../../core/auth/services/auth.service';
import { JournalPanelComponent } from '../journal-panel/journal-panel.component';

@Component({
  selector: 'app-contemplation-floating-dictation',
  standalone: true,
  imports: [CommonModule, JournalPanelComponent],
  template: `
    <div class="floating-wrap" *ngIf="isAuthed && !hideForRoute">
      <button
        *ngIf="!isOpen"
        type="button"
        class="journal-strip"
        (click)="toggle()"
        aria-label="Open journal">
        <i class="bi bi-journal-text"></i>
        <span class="strip-label">Journal</span>
      </button>

      <div class="overlay" *ngIf="isOpen">
        <div class="overlay-backdrop" (click)="close()"></div>
        <div class="overlay-panel">
          <div class="panel-topbar">
            <div class="panel-title">
              <i class="bi bi-journal-text"></i>
              <span>Journal</span>
            </div>
            <button type="button" class="btn btn-icon" (click)="close()" aria-label="Close">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="panel-body">
            <app-journal-panel [isActive]="isOpen"></app-journal-panel>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./contemplation-floating-dictation.component.scss']
})
export class ContemplationFloatingDictationComponent implements OnDestroy {
  isOpen = false;
  isAuthed = false;
  hideForRoute = false;

  private sub?: Subscription;
  private routeSub?: Subscription;

  constructor(private authService: AuthService, private router: Router) {
    this.sub = this.authService.currentUser$.subscribe(() => {
      this.syncAuthVisibility();
    });
    this.syncRouteVisibility(this.router.url);
    this.routeSub = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.syncRouteVisibility(event.urlAfterRedirects));
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.routeSub?.unsubscribe();
  }

  private syncAuthVisibility(): void {
    this.isAuthed = !!this.authService.getToken() && !!this.authService.currentUser;
    if (!this.isAuthed) {
      this.isOpen = false;
    }
  }

  private syncRouteVisibility(url: string): void {
    const path = url.split('?')[0].split('#')[0];
    // Never show journal on public auth / onboarding flows or the post-checkout pages
    this.hideForRoute =
      /\/auth(?:\/|$)/.test(path) ||
      /\/onboarding(?:\/|$)/.test(path) ||
      /\/subscription(?:\/|$)/.test(path);
    if (this.hideForRoute) {
      this.isOpen = false;
    }
  }

  toggle(): void {
    if (!this.isAuthed || this.hideForRoute) return;
    this.isOpen = !this.isOpen;
  }

  close(): void {
    this.isOpen = false;
  }
}
